export class ConceptualModelProperty {
    pimIri = null;
    /**
     * @deprecated use {@link iris} instead
     */
    cimIri = null;
    iris = [];
    humanLabel = null;
    humanDescription = null;
    cardinalityMin = null;
    cardinalityMax = null;
    dataTypes = [];
    /**
     * Whether the given property represent association that is oriented and
     * points in other direction.
     */
    isReverse = null;
}
//# sourceMappingURL=conceptual-model-property.js.map